export default __webpack_public_path__ + "static/media/1963.df7ae393.png";